import React, { useEffect, useState } from "react";
import SelectTag from "../Components/Inputs/SelectTag";
import { Label } from "@mui/icons-material";
import TextField from "../Components/Inputs/TextField";
import CustomAutoComplete from "../Components/Inputs/CustomAutoComplete";
import axios from "axios";
import {
  getCountriesData,
  getStatesData,
} from "../../../Redux/Apis/Global-Apis";
import toast from "react-hot-toast";

function GeneralDetailsEdit({ generalDetails, onClickCancel, onClickSave }) {
  let [editableGeneralDetails, setEditableGeneralDetails] =
    useState(generalDetails);

  // create validations of input

  console.log("editableGeneralDetails her eis : ", editableGeneralDetails);
  //   console.log("generalDetails her eis : ", generalDetails);

  let onChangeInput = (e) => {
    setEditableGeneralDetails((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const days = Array.from({ length: 31 }, (_, i) => ({
    label: i + 1 < 10 ? `0${i + 1}` : i + 1,
    value: i + 1 < 10 ? `0${i + 1}` : i + 1,
  }));

  const months = [
    { label: "MM", value: "MM" },
    { label: "Jan", value: "01" },
    { label: "Feb", value: "02" },
    { label: "Mar", value: "03" },
    { label: "Apr", value: "04" },
    { label: "May", value: "05" },
    { label: "Jun", value: "06" },
    { label: "Jul", value: "07" },
    { label: "Aug", value: "08" },
    { label: "Sep", value: "09" },
    { label: "Oct", value: "10" },
    { label: "Nov", value: "11" },
    { label: "Dec", value: "12" },
  ];

  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: 100 }, (_, i) => ({
    label: currentYear - i,
    value: currentYear - i,
  }));

  const onChangeDate = (field, value) => {
    let prevDob =
      editableGeneralDetails?.dob == null
        ? "YYYY-MM-DD"
        : editableGeneralDetails.dob;
    console.log("prevdob is : ", prevDob);

    let currentDOB = prevDob ? prevDob.split("-") : ["YYYY", "MM", "DD"];
    console.log("currentDOB is : ", currentDOB);

    if (field === "day") currentDOB[2] = value.value;
    if (field === "month") currentDOB[1] = value.value;
    if (field === "year") currentDOB[0] = value.value;
    let finalDob = currentDOB.join("-");

    console.log("currentDOB is : ", currentDOB);

    setEditableGeneralDetails((prev) => {
      return {
        ...prev,
        dob: finalDob,
      };
    });
  };

  const onChangeGender = (field, value) => {
    setEditableGeneralDetails((prev) => ({
      ...prev,
      [field]: value.value,
    }));
  };

  let getDateValue = (val) => {
    if (!val) return { label: "DD", value: null };
    return { label: val, value: val };
  };

  let getMonthValue = (val) => {
    console.log("value is : ", val);

    if (!val) return { label: "MM", value: null };
    return {
      label: months.filter((item) => item.value == val)[0].label,
      value: val,
    };
  };

  let getYearValue = (val) => {
    if (!val) return { label: "YYYY", value: null };
    return { label: val, value: val };
  };

  let getGenderValue = (val) => {
    if (!val) return { label: "Gender", value: null };

    return {
      label: val.charAt(0).toUpperCase() + val.slice(1),
      value: val,
    };
  };

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  let getCountryValue = (val) => {
    if (!val) return { label: "Select Country", value: null, data: null };

    return {
      label: val.name,
      value: val.code,
      data: val,
    };
  };

  let getStatesValue = (val) => {
    console.log("get state val is : ", val);

    if (!val) return { label: "Select State", value: null, data: null };

    return {
      label: val.name,
      value: val.id,
      data: val,
    };
  };

  let onChangeCountry = (value) => {
    console.log("countrychange value si : ", value);

    setEditableGeneralDetails((prev) => ({
      ...prev,
      country: value.data,
      country_id: value.data.code,
      state: null,
      state_id: null,
    }));
  };

  let onChangeState = (value) => {
    console.log("state value si : ", value);

    setEditableGeneralDetails((prev) => ({
      ...prev,
      state: value.data,
      state_id: value.data.id,
    }));
  };

  useEffect(() => {
    const fetchCountries = async () => {
      let data = await getCountriesData();

      if (data.length > 0) {
        let dd = data.map((item) => ({
          label: item.name,
          value: item.code,
          data: item,
        }));

        setCountries(dd);
      }
    };

    fetchCountries();
  }, []);

  const [dobError, setDobError] = useState("");

  const checkValidations = () => {
    if (editableGeneralDetails.dob == null) return true;
    let dob = editableGeneralDetails.dob.trim(); // Ensure no extra spaces

    // Check for incomplete date
    if (dob.includes("DD") || dob.includes("MM") || dob.includes("YYYY")) {
      setDobError("Incomplete Date");
      setTimeout(() => setDobError(""), 3000); // Clear error after 3 seconds
      return false;
    }

    // Check if dob is a future date
    let dobDate = new Date(dob);
    let today = new Date();

    if (dobDate > today) {
      setDobError("DOB Can't be a Future Date");
      setTimeout(() => setDobError(""), 3000); // Clear error after 3 seconds
      return false;
    }

    return true; // If no errors
  };

  let saveTheData = () => {
    // apply validations here and chekc them in the end do below

    let isAllValid = checkValidations();

    if (isAllValid == true) {
      console.log("editableGeneralDetails is : ", editableGeneralDetails);

      onClickSave(editableGeneralDetails, "detail");
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      if (editableGeneralDetails.country_id != null) {
        let data = await getStatesData(editableGeneralDetails.country_id);

        if (data.length > 0) {
          let dd = data.map((item) => ({
            label: item.name,
            value: item.id,
            data: item,
          }));

          setStates(dd);
        }
      }
    };

    fetchStates();
  }, [editableGeneralDetails.country_id]);

  let getTitleValue = (val) => {
    if (!val) return { label: "Title", value: null };

    return {
      label: val,
      value: val,
    };
  };

  const onChangeTitle = (field, value) => {
    setEditableGeneralDetails((prev) => ({
      ...prev,
      [field]: value.value,
    }));
  };

  return (
    <div className="userdb-content-right-internal-top">
      <div className="internal-tab-head">
        <h3>General Details</h3>
        <div className="editable-profile-action">
          <ul class="userdb-cta-buttons">
            <li class="userdb-cancel-btn" onClick={() => onClickCancel(false)}>
              Cancel
            </li>
            <li class="userdb-save-btn" onClick={() => saveTheData()}>
              Save
            </li>
          </ul>
        </div>
      </div>

      <ul className="myprofile-general-details">
        <li>
          <label for="">Name</label>

          <div
            style={{
              display: "flex",
              width: "70%",
              alignItems: "center",
            }}
          >
            <SelectTag
              value={getTitleValue(editableGeneralDetails.title)}
              width="70px"
              options={[
                { label: "Title", value: null },
                { label: "Mr", value: "Mr" },
                { label: "Ms", value: "Ms" },
                { label: "Mrs", value: "Mrs" },
                { label: "Mstr", value: "Mstr" },
              ]}
              toSkip="Title"
              dropdownWidth={"80px"}
              onChange={(value) => onChangeTitle("title", value)}
            />

            <TextField
              placeholder={"Enter First Name"}
              focus={true}
              onChange={onChangeInput}
              name="first_name"
              value={editableGeneralDetails.first_name}
            />
            <TextField
              placeholder={"Enter Last Name"}
              focus={false}
              onChange={onChangeInput}
              name="last_name"
              value={editableGeneralDetails.last_name}
            />
          </div>
        </li>
        <li>
          <label for="">Birthday</label>
          <div className="date-input-wrapper">
            <div className="date-wrapper">
              <SelectTag
                value={getDateValue(
                  editableGeneralDetails?.dob?.split("-")?.[2]
                )}
                options={[{ label: "DD", value: null }, ...days]}
                toSkip="DD"
                width="40px"
                dropdownWidth={"60px"}
                onChange={(value) => onChangeDate("day", value)}
              />

              <SelectTag
                value={getMonthValue(
                  editableGeneralDetails?.dob?.split("-")?.[1]
                )}
                width="40px"
                options={months}
                toSkip="MM"
                dropdownWidth={"80px"}
                onChange={(value) => onChangeDate("month", value)}
              />

              <SelectTag
                value={getYearValue(
                  editableGeneralDetails?.dob?.split("-")?.[0]
                )}
                width="60px"
                options={[{ label: "YYYY", value: null }, ...years]}
                toSkip="YYYY"
                dropdownWidth={"80px"}
                onChange={(value) => onChangeDate("year", value)}
              />
            </div>
            {!!dobError && (
              <div className="error font12 color_crimson proxima_regular">
                {dobError}
              </div>
            )}
          </div>
        </li>
        <li>
          <label for="">Gender</label>
          <div style={{ display: "flex", width: "70%" }}>
            <SelectTag
              value={getGenderValue(editableGeneralDetails.gender)}
              width="70px"
              options={[
                { label: "Gender", value: null },
                { label: "Male", value: "Male" },
                { label: "Female", value: "Female" },
                { label: "Other", value: "Other" },
              ]}
              toSkip="Gender"
              dropdownWidth={"80px"}
              onChange={(value) => onChangeGender("gender", value)}
            />
          </div>
        </li>
        <li>
          <label for="">Address</label>

          <TextField
            placeholder={"Enter Your Address"}
            focus={false}
            onChange={onChangeInput}
            name="address"
            value={editableGeneralDetails.address}
          />
        </li>
        <li>
          <label for="">Pin Code</label>

          <TextField
            placeholder={"Enter Your PinCode"}
            focus={false}
            onChange={onChangeInput}
            name="pincode"
            value={editableGeneralDetails.pincode}
          />
        </li>
        <li>
          <label for="">Country</label>
          <div style={{ display: "flex", width: "70%" }}>
            <CustomAutoComplete
              value={getCountryValue(editableGeneralDetails.country)}
              options={countries}
              toSkip="Select Country"
              width="50px"
              dropdownWidth={"280px"}
              onChange={(value) => onChangeCountry(value)}
            />
          </div>
        </li>
        <li>
          <label for="">State</label>
          <div style={{ display: "flex", width: "70%" }}>
            <CustomAutoComplete
              value={getStatesValue(editableGeneralDetails.state)}
              options={states}
              toSkip="Select State"
              width="50px"
              dropdownWidth={"300px"}
              onChange={(value) => onChangeState(value)}
            />
          </div>
        </li>
      </ul>
    </div>
  );
}

export default GeneralDetailsEdit;
